
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout = APP.module('Layout');

	Layout.HelpLayout = Marionette.LayoutView.extend({
		template: JST.helpLayout,
		className: 'help-page',
		regions: {
			prizes:  '.help-content',
			rules:   '.help-content',
			faqs:    '.help-content',
			terms:   '.help-content'
		}
	});

}(window, APP, Backbone, Marionette, $, _));